export default "__VITE_ASSET__fac20109__"